export default function reducer(state={
    alertShow:false
},action) {
    let { type, payload } = action;
    switch (type){
        case 'TOGGLE_ALERT':
            state = { ...state, alertShow: !state.alertShow, ...payload };
            break;
        default:
            break
    }
    return state
}


// WEBPACK FOOTER //
// ./src/reducers/alertReducer.js